export enum IntegrationTypeNum {
  GOOGLE_CLASSROOM = 1,
  MICROSOFT_TEAMS = 2,
  GOOGLE_SITES_SOURCE = 3,
  GOOGLE_SITES_DESTINATION = 4,
}
